export default () => {
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV !== 'production';
  }
  return true;
};
